import * as Data from '../api/archibus/DataApi'

export const saveVisitor = ({visitor, user}) => {
  const {firstName, lastName, company, phone, email, dv_id, dp_id} = visitor

  let parameters = {
    'visitors.name_first': firstName,
    'visitors.name_last': lastName,
    'visitors.company': company,
    'visitors.cellular_number': phone,
    'visitors.email': email,
    'visitors.entered_by': user.employee.id,
    'visitors.dv_id': dv_id,
    'visitors.dp_id': dp_id
  }

  return Data.saveDataRecord(
    'ab-self-service.axvw',
    'visitors',
    parameters
  ).then(result => {
    // Get the new visitor_id
    parameters['visitors.visitor_id'] = result.values['visitors.visitor_id']

    return Promise.resolve(parameters)
  })
}
